import React, { useMemo, useState } from 'react';
import { Input, Menu } from '../../../../ui';
import { FixedScroller } from '../../../../ui/Scrollers';
import { Skeleton } from '../../../../ui/Skeleton';
import { Flexer } from '../../../dashboard/elements/LayoutElements';

export const JiraPopperActionMenu = ({ loading, label, children }: React.PropsWithChildren<{ loading?: boolean, label?: string }>) => {
    return <Flexer role="menu" padding=".5 0" minWidth="12">
        <Menu.Section first title={label}>
            {!!loading && <>
                <Menu.Item>
                    <Skeleton />
                </Menu.Item>
                <Menu.Item>
                    <Skeleton />
                </Menu.Item>
                <Menu.Item>
                    <Skeleton />
                </Menu.Item>
            </>}
            {!loading && <>
                {children}
            </>}
        </Menu.Section>
    </Flexer>;
};

export type JiraPopperActionMenuFilterableItemsProps = {
    data: any[],
    idKey: string,
    iconKey?: string,
    labelKey: string,
    selectedKey?: string,
    onClick: (item: any) => void,
};

import Fuse from 'fuse.js';
import { Checkbox } from '../../../../ui/Checkbox';

export const JiraPopperActionMenuFilterableItems = ({ data, idKey, labelKey, iconKey, selectedKey, onClick }: JiraPopperActionMenuFilterableItemsProps) => {

    const [filter, setFilter] = useState('');
    const filteredData = useMemo(() => {
        if (!data) return null;
        if (!filter?.trim()) return data;

        const fuse = new Fuse(data, { includeScore: true, keys: [labelKey] });
        const results = fuse
            .search(filter)
            .filter(x => x.score > 0)
            .sort((a, b) => a.score - b.score)
            .map(x => x.item);
        return results;
    }, [filter, data]);

    const onApply = () => {
        if (filteredData?.length > 0) {
            onClick(filteredData[0]);
        }
    };

    return <Flexer>
        {data?.length > 10 &&
            <Flexer padding="0 .5rem .5rem .5rem">
                <Input type="text" placeholder="Search" value={filter} onChange={setFilter} onApply={onApply} autoFocus compact />
            </Flexer>
        }
        <FixedScroller maxHeight="12">
            {filteredData?.map(tm =>
                <Menu.Item key={tm[idKey]} role="menuitem" aria-label={tm[labelKey] || ''} onClick={() => onClick(tm)}>
                    {!!iconKey && <img style={{ width: '1.5rem' }} src={tm[iconKey]} />}
                    <Menu.ItemTextCropped>
                        {tm[labelKey]}
                    </Menu.ItemTextCropped>
                    {!!selectedKey &&
                        <Menu.ItemPush>
                            <Checkbox.Input type="checkbox" checked={!!tm[selectedKey]} onChange={() => { }} />
                        </Menu.ItemPush>
                    }
                </Menu.Item>
            )}
        </FixedScroller>
    </Flexer>;
};
